import { PluginConfigVersion } from '@troverecommerce/ps-configs-api-client';

interface IMapConfigVersionParams {
  type: string;
  id: string;
  attributes: PluginConfigVersion;
}

export const mapConfigVersion = (params: IMapConfigVersionParams): PluginConfigVersion => ({
  id: params.id,
  ...params.attributes,
});